// extracted by mini-css-extract-plugin
export var menuIcon = "_qv-0";
export var menuIconInline = "_qv-1";